module.exports = __webpack_public_path__ + "fonts/a8f1b92e1f979c90aa82b9753d055ea6.svg";